module.exports = __webpack_public_path__ + "static/img/fish26.e20313c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish26.png
// module id = UCld
// module chunks = 0